import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '@node-space/storybook-components/dist/Icon'
import { Description } from 'components/Text'
import { useAccountsPersonsQuery } from 'hooks/queries/useAccountsPersonsQuery'
import { IndividualVerificationDetail } from './IndividualVerificationDetail'
import { NotificationCard } from './NotificationCard/NotificationCard'

export const IndividualVerificationNotification = () => {
  const { t } = useTranslation()
  const { data: accountContacts, isLoading } = useAccountsPersonsQuery()

  const pendingIdVerificationContacts = accountContacts?.filter(
    contact => !!contact?.identifications?.length
  )

  const hasPendingIdentifications = !!pendingIdVerificationContacts?.length

  return (
    hasPendingIdentifications && (
      <NotificationCard
        title={t('verification.individual.pendingHeading')}
        iconBackground={'warning'}
        iconComponent={<Icon name="WarningCircleIcon" color="status-warning-500" size="lg" />}
      >
        <Description>{t('verification.individual.pendingSubHeading')}</Description>
        {pendingIdVerificationContacts?.map(individual => (
          <IndividualVerificationDetail key={individual?.reference} individual={individual} />
        ))}
      </NotificationCard>
    )
  )
}
